import React from 'react';
import { FullProject as Project } from '../../types';
import { ProjectCategory } from '../ProjectOverviewModal';

export interface ProjectSidebarProps {}

export interface ProjectSidebarItemProps {
  project: Project;
  isActive: boolean;
  isArchivedList: boolean;
  isCollapsed: boolean;
  isDraggingOver: boolean;
  isOpen: boolean;
  onSelect: (id: string) => void;
  onPrefetch?: (id: string) => void;
  onMenuToggle: (id: string | null) => void;
  onDragOver: (e: React.DragEvent) => void;
  onDragLeave: () => void;
  onDrop: (e: React.DragEvent) => void;
  onDuplicate: (id: string) => void;
  onRename: (id: string) => void;
  onArchiveToggle: (id: string) => void;
  onDelete: (id: string) => void;
  index: number;
  listLength: number;
  categories: ProjectCategory[];
  onAssignCategory?: (projectId: string, categoryId: string | undefined) => void;
  isReadOnly?: boolean;
}

export interface SidebarWorkspaceSwitcherProps {
  activeWorkspace: 'professional' | 'private';
  isCollapsed: boolean;
  onWorkspaceChange: (workspace: 'professional' | 'private') => void;
}

export interface SidebarNavItemsProps {
  localViewMode: string;
  isCollapsed: boolean;
  uiMode: 'standard' | 'expert';
  isStrategyOpen: boolean;
  isStrategyActive: boolean;
  onToggleStrategy: () => void;
  onSelect: (viewMode: string) => void;
  onPrefetch?: (viewMode: string) => void;
}

export interface SidebarProjectListProps {
  visibleProjects: Project[];
  activeWorkspace: 'professional' | 'private';
  isCollapsed: boolean;
  localActiveId: string;
  localViewMode: string;
  openMenuId: string | null;
  categories: ProjectCategory[];
  currentUserId?: string;
  currentUserEmail?: string | null;
  onReorderProjects: (newOrder: Project[]) => void;
  onSelect: (id: string) => void;
  onPrefetch?: (id: string) => void;
  onMenuToggle: (id: string | null) => void;
  onDuplicateProject: (id: string) => void;
  onRenameProject: (id: string) => void;
  onArchiveToggle: (id: string, isArchived: boolean) => void;
  onDeleteProject: (id: string) => void;
  onUpdateProjectCategory: (projectId: string, categoryId: string | undefined) => void;
}

export interface SidebarFooterProps {
  isCollapsed: boolean;
  isCreatingProject: boolean;
  onAddProject: () => void;
}

export const SYSTEM_PROJECT_IDS = ['kommunikation', 'inbox_inforum', 'posteingang', 'communication', 'comm_internal', 'inbox'] as const;
export const SYSTEM_PROJECT_NAMES = ['kommunikation', 'posteingang', 'inbox', 'inforum-inbox'] as const;
export const GLOBAL_VIEW_IDS = ['dashboard', 'metricsDashboard', 'globalKanban', 'communication', 'impactEffort', 'noDateTasks', 'global', 'globalCalendar', 'aiAssistant', 'analysis', 'projectPool', 'globalGantt'] as const;
export const PERSISTENT_PROJECT_VIEWS = ['kanban', 'gantt', 'list', 'calendar', 'projectContact', 'timeline', 'mindmap', 'analysis'] as const;
